module.exports = __webpack_public_path__ + "media/images/members/alejandra_ulla_lorenzo-2c547dc43a706c04609802e94f28201c.jpg";